
import { Vue } from 'vue-class-component';

export default class NotFound extends Vue {
beforeMount(){
    this.$router.push('/top');
  }
}
